import React from 'react';
import {useDropzone} from "react-dropzone";
import {IconButton} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import ArticleIcon from "@mui/icons-material/Article";

import useFeature from "../../useFeature";
import {FileUploadFeature} from "./FileUploadFeature";
import {observer} from "mobx-react";

const FileUploadSection = ({ title = "Comprobante de Pago", onFilesChange, placeholder = "Ingresar comprobante de pago", singleFile = true, isRequired = false, initialFiles = [] }) => {
    const feature = useFeature(() => new FileUploadFeature(singleFile, onFilesChange, initialFiles));

    const isFeatureReady = () => {
        return feature && feature.loaded;
    };

    const handleFilesAdded = (acceptedFiles) => {
        feature.addFiles(acceptedFiles);
    };

    const handleFileRemoved = (index) => {
        feature.removeFile(index);
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: handleFilesAdded,
        multiple: true,
        accept: isFeatureReady() ? feature.acceptedFileTypes().join(',') : '.pdf,.jpg,.jpeg,.png,.docx',
        name: 'files[]',
        type: 'file',
    });

    if (!isFeatureReady()) {
        return null;
    }

    const hasFiles = feature.hasFiles();

    return (
        <div className="mb-4 text-start">
            <p className="general-title">
                {title}
                {isRequired && <span style={{color: "#dc3545", marginLeft: "5px"}}>*</span>}
            </p>
            <div
                {...getRootProps()}
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: isRequired && !hasFiles ? "2px solid #dc3545" : "1px solid #ced4da",
                    borderRadius: "5px",
                    padding: "20px",
                    backgroundColor: isRequired && !hasFiles ? "#fdf2f2" : "#f8f9fa",
                    cursor: "pointer",
                    marginBottom: "1em",
                    width: "100%",
                }}
            >
                <input {...getInputProps()} accept={feature.acceptedFileTypes().join(',')}/>
                <button
                    style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#007bff",
                        cursor: "pointer",
                        padding: "5px 10px",
                        fontSize: "16px",
                        marginRight: "10px",
                    }}
                >
                    <ArticleIcon sx={{color: isRequired && !hasFiles ? '#dc3545' : 'gray'}}/>
                </button>
                <span style={{
                    color: isRequired && !hasFiles ? '#dc3545' : 'inherit',
                    fontWeight: isRequired && !hasFiles ? 'bold' : 'normal'
                }}>
                    {hasFiles ?
                        (feature.singleFileMode ? `1 archivo seleccionado` : `${feature.files.length} archivo(s) seleccionado(s)`) 
                        : placeholder
                    }
                </span>
            </div>

            {feature.fileError && <div style={{color: "red", fontSize: "14px", marginTop: "10px"}}>{feature.fileError}</div>}

            {hasFiles && (
                <div style={{paddingLeft: "1em", fontSize: "14px"}}>
                    <ul style={{listStyleType: "none", padding: 0}}>
                        {feature.files.map((file, index) => (
                            <li key={index} style={{marginBottom: "0.5em", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <span>{file.name}</span>
                                <IconButton 
                                    size="small" 
                                    onClick={() => handleFileRemoved(index)}
                                    sx={{ color: 'red', padding: '2px' }}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default observer(FileUploadSection); 